import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageHero from "@/components/feature/PageHero";
import { termSchedule, vacationSchedule } from "@/mocks/schedule";
import Timetable from "./components/Timetable";
import ConsultCTA from "@/pages/home/components/ConsultCTA";

export default function Schedule() {
  const location = useLocation();
  const [tab, setTab] = useState<"term" | "vacation">("term");

  useEffect(() => {
    if (location.hash === "#vacation") setTab("vacation");
    else if (location.hash === "#term") setTab("term");
  }, [location.hash]);

  const data = tab === "term" ? termSchedule : vacationSchedule;

  return (
    <>
      <PageHero
        tag="SCHEDULE"
        title={
          <>
            학기중 · 방학중
            <br />
            <span className="text-primary-500">시간표 안내</span>
          </>
        }
        description="정규 학기와 방학 특강의 시간표를 안내합니다. 시간표는 학기마다 조정될 수 있으니, 상담을 통해 현재 개설된 반을 확인해 주세요."
        image="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20composition%20with%20glowing%20lime%20green%20circular%20clock%20inspired%20geometry%20and%20calendar%20grid%20patterns%20over%20a%20deep%20charcoal%20background%2C%20soft%20volumetric%20light%2C%20minimal%20editorial%20poster%20art%2C%20cinematic%20depth%2C%20no%20text&width=1920&height=720&seq=mbhj-schedule-hero-01&orientation=landscape"
      />

      <section className="bg-background-100 py-16 md:py-24">
        <div className="mx-auto max-w-content px-5 md:px-8">
          <div className="flex flex-col items-center">
            <div className="flex items-center gap-1 rounded-full border border-background-200 bg-background-50 p-1">
              <button
                type="button"
                onClick={() => setTab("term")}
                className={`whitespace-nowrap rounded-full px-6 py-2.5 text-sm font-bold transition-colors cursor-pointer ${
                  tab === "term"
                    ? "bg-primary-500 text-foreground-950"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                학기중
              </button>
              <button
                type="button"
                onClick={() => setTab("vacation")}
                className={`whitespace-nowrap rounded-full px-6 py-2.5 text-sm font-bold transition-colors cursor-pointer ${
                  tab === "vacation"
                    ? "bg-primary-500 text-foreground-950"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                방학중
              </button>
            </div>
            <p className="mt-4 max-w-md text-center text-sm text-foreground-700">
              {tab === "term"
                ? "정규 학기에는 학년·수준별 반이 요일별로 운영됩니다."
                : "방학에는 선행 특강과 복습 클리닉을 집중 운영합니다."}
            </p>
          </div>

          <Timetable schedule={data} />
        </div>
      </section>

      <ConsultCTA />
    </>
  );
}